import { req } from '../utils/request'

/**
 * 用户端会员发票 API。
 *
 * 发票申请接口保存当次申请快照；发票抬头接口维护可复用的常用资料。
 */
export class Invoice {
  getList(params) {
    return req.post('user.invoice/getList', params)
  }

  getDetail(params) {
    return req.post('user.invoice/getDetail', params)
  }

  reusableTitle(params) {
    return req.post('user.invoice/reusableTitle', params)
  }

  titleList(params) {
    return req.post('user.invoice/titleList', params)
  }

  deleteTitle(params) {
    return req.post('user.invoice/deleteTitle', params)
  }

  saveTitle(params) {
    return req.post('user.invoice/saveTitle', params)
  }

  setDefaultTitle(params) {
    return req.post('user.invoice/setDefaultTitle', params)
  }

  submit(params) {
    return req.post('user.invoice/submit', params)
  }
}

export default new Invoice()
